// WK-20261021-02 : 전 회사 공통 시스템 공지의 표시 억제 규칙. FERP WK-20261021-01(systemNotice.ftl)과 같은 규칙이다.
//
// 억제는 공지 ID별이다.
// - "Don't show again today": localStorage, 브라우저 로컬 날짜.
// - 같은 탭 로그인 화면에서 이미 본 공지: sessionStorage, 로그인 직후 화면이 소비한다.
// - 로그인 직후 표시 대기(pending): sessionStorage. 탭마다 따로라 다른 탭이 소비하지 않는다.
//   인증 정보를 담는 vue-session 은 persist(localStorage, 탭 공유)라 여기에 쓰지 않는다.
// 저장소가 없거나 예외를 던지면 그 저장소의 기능만 건너뛴다(공지는 표시된다).

export const HIDE_PREFIX = 'herp_sysnotice_hide_';
export const SEEN_PREFIX = 'herp_sysnotice_seen_';
export const PENDING_KEY = 'herp_sysnotice_pending';

// window.localStorage 접근 자체가 예외를 던질 수 있다(저장소 차단).
export function browserStorage(name) {
	try {
		return window[name] || null;
	} catch (e) {
		return null;
	}
}

export function localToday(date) {
	const month = date.getMonth() + 1;
	const day = date.getDate();
	return date.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
}

// 아직 보여 줄 ID. 로그인 화면은 오늘 숨긴 ID만 뺀다.
// 로그인 직후는 같은 탭 로그인 화면에서 이미 본 ID도 빼고, 현재 ID 모두의 그 기록을 소비한다.
export function visibleIds(ids, page, today, local, session) {
	const visible = [];
	for (let i = 0; i < ids.length; i++) {
		const id = ids[i];
		let show = true;
		try {
			const hidden_day = local.getItem(HIDE_PREFIX + id);
			if (hidden_day === today) show = false;
			else if (hidden_day !== null) local.removeItem(HIDE_PREFIX + id);
		} catch (e) {
			// 숨김 기록을 읽지 못하면 숨기지 않는다.
		}
		if (page !== 'login') {
			try {
				if (session.getItem(SEEN_PREFIX + id) !== null) show = false;
				session.removeItem(SEEN_PREFIX + id);
			} catch (e) {
				// seen 기록을 읽지 못하면 다시 보여 준다.
			}
		}
		if (show) visible.push(id);
	}
	return visible;
}

export function markSeen(ids, session) {
	for (let i = 0; i < ids.length; i++) {
		try {
			session.setItem(SEEN_PREFIX + ids[i], '1');
		} catch (e) {
			// 기록하지 못하면 로그인 직후에 한 번 더 보일 뿐이다.
		}
	}
}

export function hideToday(ids, today, local) {
	for (let i = 0; i < ids.length; i++) {
		try {
			local.setItem(HIDE_PREFIX + ids[i], today);
		} catch (e) {
			// 기록하지 못하면 다음에 다시 보인다.
		}
	}
}

// 로그인 시도마다 다른 값을 남긴다. 오래된 요청이 새 로그인의 pending 을 지우지 않게 값으로 구분한다.
export function setPending(session) {
	try {
		const nonce = Math.random()
			.toString(36)
			.slice(2);
		session.setItem(PENDING_KEY, Date.now() + '-' + nonce);
	} catch (e) {
		// 기록하지 못하면 로그인 직후 표시만 생략된다. 로그인은 그대로 진행한다.
	}
}

export function readPending(session) {
	try {
		return session.getItem(PENDING_KEY);
	} catch (e) {
		return null;
	}
}

export function clearPendingIf(session, value) {
	try {
		if (value !== null && session.getItem(PENDING_KEY) === value) session.removeItem(PENDING_KEY);
	} catch (e) {
		// 지우지 못하면 같은 탭의 다음 화면에서 한 번 더 시도한다.
	}
}
